import { useEffect, useRef, useState } from "react";

import { Waveform, WaveformCfg, WaveformEventType } from "../../lib/waveform";

import { isEqual } from "lodash";

interface useWaveformProps {
  canvas: HTMLCanvasElement | null;
  cfg: WaveformCfg;
}
const stubUpdateEvents = (newEvents: WaveformEventType[]) => {};
const stubUpdateFFTData = ({
  chunk,
  timestamp,
}: {
  chunk: Float32Array;
  timestamp: number;
}) => {};

export const useWaveform = ({ canvas, cfg }: useWaveformProps) => {
  const waveformRef = useRef<Waveform | null>(null);

  const [_cfg, _setCfg] = useState<WaveformCfg>({});

  useEffect(() => {
    if (!isEqual(_cfg, cfg)) {
      _setCfg(cfg);
    }
  }, [cfg]);

  useEffect(() => {
    if (waveformRef.current) {
      waveformRef.current.stop();
      waveformRef.current = null;
    }
    if (canvas) {
      waveformRef.current = new Waveform(canvas, _cfg, true);
    }
  }, [canvas, _cfg]);

  return {
    updateEvents: waveformRef.current?.addEvents || stubUpdateEvents,
    updateFFTData: waveformRef.current?.addFFTData || stubUpdateFFTData,
    fftSize: waveformRef.current?.FFT_SIZE || 0,
  };
};

export { WaveformCfg, WaveformEventType } from "../../lib/waveform";
